<template xs12 sm3>
    <div class="empleado-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="750" scrollable>
                    <v-card>
                        <v-toolbar card prominent color="primary" dark dense>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa fa-close</v-icon>
                            </v-btn>
                            <template slot="extension">
                                <v-tabs color="primary darken-1" dark grow slider-color="yellow" v-model="activeTab">
                                    <v-tab :key="1" :href="`#tab-1`">
                                        Información Personal
                                    </v-tab>
                                    <v-tab :key="2" :href="`#tab-2`">
                                        Contacto
                                    </v-tab>
                                    <v-tab :key="3" :href="`#tab-3`">
                                        Asignación
                                    </v-tab>
                                    <v-tab :key="4" :href="`#tab-4`">
                                        Salario
                                    </v-tab>
                                    <v-tab :key="5" :href="`#tab-5`">
                                        Contrato
                                    </v-tab>
                                    <v-tab :key="6" :href="`#tab-6`">
                                        Documentación
                                    </v-tab>
                                </v-tabs>
                            </template>
                        </v-toolbar>
                        <v-flex>
                            <div slot="widget-content">
                                <v-alert
                                    v-model="showErrorAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    Existen errores de validación, revise los datos e intente nuevamente
                                </v-alert>
                                <v-alert
                                    v-model="showErrorDataLoadedAlert"
                                    type="error"
                                    dismissible
                                    transition="scale-transition"
                                    dark
                                >
                                    No se han podido cargar todos los datos necesarios para este formulario, intente
                                    cargar el formulario nuevamente.
                                </v-alert>
                            </div>
                        </v-flex>
                        <v-card-text>
                            <v-form ref="empleadoForm" v-model="validEmpleado">
                                <v-tabs-items v-model="activeTab">
                                    <v-tab-item :key="1" :value="`tab-1`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.codigo"
                                                        label="Código*"
                                                        :counter="30"
                                                        :rules="codigoFieldRules"
                                                        :error-messages="codigoFieldErrors"
                                                        @blur="codigoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.nombre"
                                                        label="Nombre*"
                                                        :counter="255"
                                                        :rules="nombreFieldRules"
                                                        :error-messages="nombreFieldErrors"
                                                        @blur="nombreFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.apellido_paterno"
                                                        label="Apellido paterno*"
                                                        :counter="255"
                                                        :rules="apellido_paternoFieldRules"
                                                        :error-messages="apellido_paternoFieldErrors"
                                                        @blur="apellido_paternoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.apellido_materno"
                                                        label="Apellido materno*"
                                                        :counter="255"
                                                        :rules="apellido_maternoFieldRules"
                                                        :error-messages="apellido_maternoFieldErrors"
                                                        @blur="apellido_maternoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-menu
                                                        ref="menuFechaNacido"
                                                        v-model="menuFechaNacido"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaNacidoFormatted"
                                                                label="Fecha de nacimiento*"
                                                                v-on="on"
                                                                readonly
                                                                :rules="fecha_nacidoFieldRules"
                                                                :error-messages="fecha_nacidoFieldErrors"
                                                                @blur="
                                                                    dateFecha_nacido = parseDate(
                                                                        empleadoItem.fecha_nacido
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_nacido"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaNacido = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-menu
                                                        ref="menuFechaIngreso"
                                                        v-model="menuFechaIngreso"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        lazy
                                                        transition="scale-transition"
                                                        offset-y
                                                        full-width
                                                        min-width="290px"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field
                                                                v-model="computedFechaIngresoFormatted"
                                                                label="Fecha de ingreso"
                                                                :error-messages="fecha_ingresoFieldErrors"
                                                                readonly
                                                                v-on="on"
                                                                @blur="
                                                                    dateFecha_ingreso = parseDate(
                                                                        empleadoItem.fecha_ingreso
                                                                    )
                                                                "
                                                            >
                                                            </v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateFecha_ingreso"
                                                            no-title
                                                            scrollable
                                                            locale="es-es"
                                                            @input="menuFechaIngreso = false"
                                                        >
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                      <!--    Aqui se agrega CURP y RFC nuevo -->

                                                <v-flex xs12 sm10>
                                                    <label class="v-text-field v-label" style="color: rgba(0,0,0,0.54)">
                                                        Estado civil*:
                                                    </label>
                                                    <v-radio-group
                                                        v-model="empleadoItem.estado_civil_id"
                                                        row
                                                        color="primary"
                                                        :rules="estado_civilFieldRules"
                                                        :error-messages="estado_civilFieldErrors"
                                                    >
                                                        <v-radio
                                                            :label="estadoC.nombre"
                                                            :value="estadoC.id"
                                                            :key="estadoC.id"
                                                            v-for="estadoC in ESTADOS_CIVIL"
                                                            @change="estado_civilFieldErrors = []"
                                                        >
                                                        </v-radio>
                                                        <v-icon @click="showEstadoCivilForm = true">add</v-icon>
                                                    </v-radio-group>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.curp"
                                                        label="CURP"
                                                        :counter="30"
                                                        :error-messages="curpFieldErrors"
                                                        @blur="curpFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.rfc"
                                                        label="RFC"
                                                        type="number"
                                                        :counter="30"
                                                        :error-messages="curpFieldErrors"
                                                        @blur="curpFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm3>
                                                    <v-select
                                                        v-model="empleadoItem.sexo_id"
                                                        :items="SEXOS"
                                                        label="Género*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="sexoFieldRules"
                                                        :error-messages="sexoFieldErrors"
                                                        @blur="sexoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showSexoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm3>
                                                    <v-text-field
                                                        v-model="empleadoItem.hijos"
                                                        label="Hijos"
                                                        type="number"
                                                        :counter="2"
                                                        :error-messages="curpFieldErrors"
                                                        @blur="curpFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <label for="file-upload" class="v-btn" style="cursor: pointer">
                                                        <v-icon class="pr-1">fa fa-cloud-upload</v-icon> Imagen
                                                    </label>
                                                    <input
                                                        ref="file"
                                                        id="file-upload"
                                                        type="file"
                                                        @change="onChangeFileUpload()"
                                                        accept="image/*"
                                                    />
                                                    <br />
                                                    <div class="error_message">
                                                        {{ fotoFieldErrors[0] }}
                                                    </div>
                                                    {{
                                                        empleadoItem.foto.length === 0
                                                            ? "Seleccione una imagen..."
                                                            : empleadoItem.foto.name
                                                    }}
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="2" :value="`tab-2`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>

                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.direccion"
                                                        label="Domicilio"
                                                        :counter="255"
                                                        :error-messages="direccionFieldErrors"
                                                        @blur="direccionFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.telefono"
                                                        label="Teléfono"
                                                        :counter="10"
                                                        :error-messages="telefonoFieldErrors"
                                                        @blur="telefonoFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.celular"
                                                        label="Celular"
                                                        :counter="10"
                                                        :error-messages="celularFieldErrors"
                                                        @blur="celularFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.email"
                                                        label="Correo"
                                                        :counter="255"
                                                        :error-messages="emailFieldErrors"
                                                        @blur="emailFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.cedula"
                                                        label="Cédula"
                                                        :counter="30"
                                                        :error-messages="cedulaFieldErrors"
                                                        @blur="cedulaFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="3" :value="`tab-3`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.campus_id"
                                                        :items="CAMPUS"
                                                        label="Campus*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="campusFieldRules"
                                                        :error-messages="campusFieldErrors"
                                                        @blur="campusFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.departamento_id"
                                                        :items="DEPARTAMENTOS"
                                                        label="Departamento*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="departamentoFieldRules"
                                                        :error-messages="departamentoFieldErrors"
                                                        @blur="departamentoFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-if="empleadoItem.departamento_id === 3"
                                                        v-model="empleadoItem.seccion_id"
                                                        :items="
                                                            SECCIONES.filter(
                                                                el => el.campus_id === empleadoItem.campus_id
                                                            )
                                                        "
                                                        label="Sección*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="seccionFieldRules"
                                                        :error-messages="seccionFieldErrors"
                                                        @blur="seccionFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.puesto_id"
                                                        :items="PUESTOS"
                                                        label="Puesto*"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        :rules="puestoFieldRules"
                                                        :error-messages="puestoFieldErrors"
                                                        @blur="puestoFieldErrors = []"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showPuestoForm = true"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.escolaridad_id"
                                                        :items="ESCOLARIDADES"
                                                        label="Escolaridad"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showEscolaridadForm = true"
                                                        :error-messages="escolaridadesFieldErrors"
                                                        @blur="escolaridadesFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.titulo_id"
                                                        :items="TITULOS"
                                                        label="Titulo"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        append-outer-icon="add"
                                                        @click:append-outer="showTituloForm = true"
                                                        :error-messages="tituloFieldErrors"
                                                        @blur="tituloFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="4" :value="`tab-4`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.tipo_pago"
                                                        :items="[
                                                            { text: 'Fijo', value: 1 },
                                                            { text: 'Por horas', value: 2 }
                                                        ]"
                                                        label="Tipo de pago*"
                                                        :rules="tipo_pagoFieldRules"
                                                        :error-messages="tipo_pagoFieldErrors"
                                                        @blur="tipo_pagoFieldErrors = []"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 v-if="empleadoItem.tipo_pago === 2">
                                                    <v-text-field
                                                        v-model="empleadoItem.fondo_horario"
                                                        label="Cantidad de horas*"
                                                        type="number"
                                                        :rules="cantidad_horasFieldRules"
                                                        :error-messages="cantidad_horasFieldErrors"
                                                        @blur="cantidad_horasFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 :class="empleadoItem.tipo_pago !== 2 ? 'sm6' : 'sm4'">
                                                    <v-text-field
                                                        v-model="empleadoItem.salario"
                                                        label="Salario*"
                                                        prefix="MX"
                                                        type="number"
                                                        :rules="salarioFieldRules"
                                                        :error-messages="salarioFieldErrors"
                                                        @blur="salarioFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm1 v-show="empleadoItem.tipo_pago === 2"> </v-flex>
                                                <v-flex xs12 sm2>
                                                    <v-label>Asesor?</v-label>
                                                    <v-switch
                                                        class="mt-0"
                                                        v-model="empleadoItem.asesor"
                                                        :label="empleadoItem.asesor ? 'Si' : 'No'"
                                                        :error-messages="asesorFieldErrors"
                                                        @change="asesorFieldErrors = []"
                                                    >
                                                    </v-switch>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-text-field
                                                        v-if="empleadoItem.asesor"
                                                        v-model="empleadoItem.plus"
                                                        label="Salario plus*"
                                                        prefix="MX"
                                                        type="number"
                                                        :rules="salario_plusFieldRules"
                                                        :error-messages="salario_plusFieldErrors"
                                                        @blur="salario_plusFieldErrors = []"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="5" :value="`tab-5`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-select
                                                        v-model="empleadoItem.tipo_contratacion"
                                                        :items="[
                                                            { text: 'COLEGIO_IMSS', value: 1 },
                                                            { text: 'COLEGIO_HONORARIOS', value: 2 },
                                                            { text: 'OUTSOURCING_IMSS', value: 3 },
                                                            { text: 'OUTSOURCING_HONORARIOS', value: 4 }
                                                        ]"
                                                        label="Tipo de contrato*"
                                                        :rules="tipo_contratoFieldRules"
                                                        :error-messages="tipo_contratoFieldErrors"
                                                        @blur="tipo_contratoFieldErrors = []"
                                                        @change="contratacionDisableFields()"
                                                    >
                                                    </v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.impuesto_nomina"
                                                        label="Impuesto nómina"
                                                        type="number"
                                                        :error-messages="impuesto_nominaFieldErrors"
                                                        @blur="impuesto_nominaFieldErrors = []"
                                                        :disabled="disabledFields.includes(1)"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.cuota"
                                                        label="Cuota"
                                                        type="number"
                                                        :error-messages="cuotaFieldErrors"
                                                        @blur="cuotaFieldErrors = []"
                                                        :disabled="disabledFields.includes(2)"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.isr"
                                                        label="ISR"
                                                        type="number"
                                                        :error-messages="isrFieldErrors"
                                                        @blur="isrFieldErrors = []"
                                                        :disabled="disabledFields.includes(3)"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-text-field
                                                        v-model="empleadoItem.imss"
                                                        label="IMSS"
                                                        type="number"
                                                        :error-messages="imssFieldErrors"
                                                        @blur="imssFieldErrors = []"
                                                        :disabled="disabledFields.includes(4)"
                                                    >
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                    <v-tab-item :key="6" :value="`tab-6`">
                                        <v-container fluid grid-list-xl>
                                            <v-layout align-center wrap>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="empleadoItem.ractanacido"
                                                        label="Acta de nacimiento"
                                                        :error-messages="racta_nacidoFieldErrors"
                                                        @blur="racta_nacidoFieldErrors = []"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="empleadoItem.rcedula"
                                                        label="Cédula"
                                                        :error-messages="rcedulaFieldErrors"
                                                        @blur="rcedulaFieldErrors = []"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="empleadoItem.rcurp"
                                                        label="CURP"
                                                        :error-messages="rcurpFieldErrors"
                                                        @blur="rcurpFieldErrors = []"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="empleadoItem.rtitulo"
                                                        label="Título"
                                                        :error-messages="rtituloFieldErrors"
                                                        @blur="rtituloFieldErrors = []"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-checkbox
                                                        v-model="empleadoItem.rdomicilio"
                                                        label="Domicilio"
                                                        :error-messages="rdomicilioFieldErrors"
                                                        @blur="rdomicilioFieldErrors = []"
                                                    >
                                                    </v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <small class="ml-2">(*) indica campos requeridos</small>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <sexo-form
            v-if="showSexoForm"
            form-title="Nuevo sexo"
            :initial-item="null"
            @formCanceled="showSexoForm = false"
        >
        </sexo-form>
        <estado-civil-form
            v-if="showEstadoCivilForm"
            form-title="Nuevo estado civil"
            :initial-item="null"
            @formCanceled="showEstadoCivilForm = false"
        >
        </estado-civil-form>
        <puesto-form
            v-if="showPuestoForm"
            form-title="Nuevo puesto"
            :initial-item="null"
            @formCanceled="showPuestoForm = false"
        >
        </puesto-form>
        <escolaridad-form
            v-if="showEscolaridadForm"
            form-title="Nueva escolaridad"
            :initial-item="null"
            @formCanceled="showEscolaridadForm = false"
        >
        </escolaridad-form>
        <titulo-form
            v-if="showTituloForm"
            form-title="Nuevo título"
            :initial-item="null"
            @formCanceled="showTituloForm = false"
        >
        </titulo-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Util from "@/util"
const SexoForm = () => import("@/components/personal/nomencladores/sexo-form/sexo-form")
const EstadoCivilForm = () => import("@/components/personal/nomencladores/estado-civil-form/estado-civil-form")
const PuestoForm = () => import("@/components/personal/nomencladores/puesto-form/puesto-form")
const EscolaridadForm = () => import("@/components/personal/nomencladores/escolaridad-form/escolaridad-form")
const TituloForm = () => import("@/components/personal/nomencladores/titulo-form/titulo-form")

export default {
    components: {
        TituloForm,
        EscolaridadForm,
        PuestoForm,
        EstadoCivilForm,
        SexoForm
    },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            activeTab: "tab-1",
            loading: false,
            validEmpleado: false,
            empleadoItem: {
                codigo: "",
                nombre: "",
                apellido_paterno: "",
                apellido_materno: "",
                fecha_nacido: this.formatDate(new Date().toISOString().substr(0, 10)),
                direccion: "",
                telefono: "",
                celular: "",
                puesto_id: null,
                campus_id: "",
                seccion_id: "",
                departamento_id: null,
                cedula: "",
                estado_civil_id: 1,
                sexo_id: "",
                email: "",
                tipo_contratacion: null,
                curp: "",
                fecha_ingreso: this.formatDate(new Date().toISOString().substr(0, 10)),
                escolaridad_id: "",
                titulo_id: "",
                foto: [],
                rcedula: true,
                rdomicilio: true,
                rtitulo: true,
                ractanacido: true,
                rcurp: true,
                tipo_pago: "",
                salario: "",
                fondo_horario: "",
                impuesto_nomina: "",
                cuota: "",
                isr: "",
                imss: "",
                asesor: "",
                plus: "",
                rfc:"",
                hijos:""
            },
            menuFechaIngreso: false,
            menuFechaNacido: false,
            dateFecha_nacido: new Date().toISOString().substr(0, 10),
            dateFecha_ingreso: new Date().toISOString().substr(0, 10),

            //validaciones
            codigoFieldRules: [
                v => !!v || "Debe proporcionar un código",
                v => v.length <= 30 || "El código solo puede contener 30 caracteres"
            ],
            codigoFieldErrors: [],
            nombreFieldRules: [
                v => !!v || "Debe proporcionar un nombre",
                v => v.length <= 255 || "El nombre solo puede contener 255 caracteres"
            ],
            nombreFieldErrors: [],
            apellido_paternoFieldRules: [
                v => !!v || "Debe proporcionar el apellido paterno",
                v => v.length <= 255 || "El apellido paterno solo puede contener 255 caracteres"
            ],
            apellido_paternoFieldErrors: [],
            apellido_maternoFieldRules: [
                v => !!v || "Debe proporcionar el apellido materno",
                v => v.length <= 255 || "El apellido materno solo puede contener 255 caracteres"
            ],
            apellido_maternoFieldErrors: [],
            fecha_nacidoFieldRules: [v => !!v || "Debe proporcionar la fecha de nacimiento"],
            fecha_nacidoFieldErrors: [],
            sexoFieldRules: [v => !!v || "Debe proporcionar el Género"],
            sexoFieldErrors: [],
            estado_civilFieldRules: [v => !!v || "Debe proporcionar el estado civil"],
            estado_civilFieldErrors: [],
            campusFieldRules: [v => !!v || "Debe proporcionar el campus"],
            campusFieldErrors: [],
            departamentoFieldRules: [v => !!v || "Debe proporcionar el departamento"],
            departamentoFieldErrors: [],
            seccionFieldRules: [v => (this.computedDepartamentoSeccion && !!v) || "Debe proporcionar la sección"],
            seccionFieldErrors: [],
            puestoFieldRules: [v => !!v || "Debe proporcionar el puesto"],
            puestoFieldErrors: [],
            tipo_pagoFieldRules: [v => !!v || "Debe proporcionar el tipo de pago"],
            tipo_pagoFieldErrors: [],
            tipo_contratoFieldRules: [v => !!v || "Debe proporcionar el tipo de contrato"],
            tipo_contratoFieldErrors: [],
            cantidad_horasFieldRules: [
                v => (this.computedPagoHoras && !!v) || "Debe proporcionar la cantidad de horas",
                v => v > 0 || "La cantidad de horas debe ser mayor que 0"
            ],
            cantidad_horasFieldErrors: [],
            salarioFieldRules: [
                v => !!v || "Debe proporcionar el salario",
                v => v > 0 || "El salario debe ser mayor que 0"
            ],
            salarioFieldErrors: [],
            salario_plusFieldRules: [
                v => (this.computedSalarioAsesor && !!v) || "Debe proporcionar el plus de salario",
                v => v > 0 || "El plus de salario debe ser mayor que 0"
            ],
            cedulaFieldErrors: [],
            curpFieldErrors: [],
            rfcFieldErrors: [],
            hijosFieldErrors: [],
            emailFieldErrors: [],
            direccionFieldErrors: [],
            telefonoFieldErrors: [],
            celularFieldErrors: [],
            fecha_ingresoFieldErrors: [],
            fotoFieldErrors: [],
            rcedulaFieldErrors: [],
            rdomicilioFieldErrors: [],
            rtituloFieldErrors: [],
            racta_nacidoFieldErrors: [],
            rcurpFieldErrors: [],
            salario_plusFieldErrors: [],
            impuesto_nominaFieldErrors: [],
            cuotaFieldErrors: [],
            isrFieldErrors: [],
            imssFieldErrors: [],
            escolaridadesFieldErrors: [],
            asesorFieldErrors: [],
            tituloFieldErrors: [],

            //formularios nuevos nomencladores
            showSexoForm: false,
            showEstadoCivilForm: false,
            showPuestoForm: false,
            showEscolaridadForm: false,
            showTituloForm: false,

            //alert errores de validacion
            showErrorAlert: false,

            //campos de tipo_contratacion deshabilitados
            disabledFields: [],

            //saber si se cargaron todos los datos necesarios para el formulario
            showErrorDataLoadedAlert: false
        }
    },
    computed: {
        ...mapGetters([
            "CAMPUS",
            "SECCIONES",
            "DEPARTAMENTOS",
            "PUESTOS",
            "ESCOLARIDADES",
            "TITULOS",
            "ESTADOS_CIVIL",
            "SEXOS"
        ]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validEmpleado || this.fotoFieldErrors.length > 0
        },

        computedPagoHoras() {
            return this.empleadoItem.tipo_pago === 2
        },

        computedDepartamentoSeccion() {
            return this.empleadoItem.departamento_id === 3
        },

        computedSalarioAsesor() {
            return this.empleadoItem.asesor
        },

        computedFechaNacidoFormatted() {
            return this.formatDate(this.dateFecha_nacido)
        },

        computedFechaIngresoFormatted() {
            return this.formatDate(this.dateFecha_ingreso)
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.empleadoForm.validate()
            if (this.validEmpleado) {
                let empleado = new FormData()

                Object.entries(this.empleadoItem).forEach(([key, value]) => {
                    empleado.append(key, value)
                })
                empleado.append("asesor", this.empleadoItem.asesor ? 1 : 0)
                empleado.append("rcedula", this.empleadoItem.rcedula ? 1 : 0)
                empleado.append("rcurp", this.empleadoItem.rcurp ? 1 : 0)
                empleado.append("rdomicilio", this.empleadoItem.rdomicilio ? 1 : 0)
                empleado.append("rtitulo", this.empleadoItem.rtitulo ? 1 : 0)
                empleado.append("ractanacido", this.empleadoItem.ractanacido ? 1 : 0)

                if (this.empleadoItem.foto !== "") {
                    empleado.append("Empleado[file]", this.empleadoItem.foto)
                }

                if (!this.isNewRecord) {
                    empleado.append("id", this.initialItem.id)
                }
                this.$store.dispatch(this.isNewRecord ? "ADD_EMPLEADO" : "UPDATE_EMPLEADO", empleado).then(result => {
                    if (!result) {
                        this.loading = false
                    }
                    if (result === null || result.status === 404 || result.status === 500) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe o no hay coneccion con el servidor
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            this.showErrorAlert = true
                            data.forEach(error => {
                                console.log(error.message)
                                switch (error.field) {
                                    case "codigo":
                                        this.codigoFieldErrors.push(error.message)
                                        break
                                    case "nombre":
                                        this.nombreFieldErrors.push(error.message)
                                        break
                                    case "apellido_paterno":
                                        this.apellido_paternoFieldErrors.push(error.message)
                                        break
                                    case "apellido_materno":
                                        this.apellido_maternoFieldErrors.push(error.message)
                                        break
                                    case "cedula":
                                        this.cedulaFieldErrors.push(error.message)
                                        break
                                    case "curp":
                                        this.curpFieldErrors.push(error.message)
                                        break
                                    case "fecha_nacido":
                                        this.fecha_nacidoFieldErrors.push(error.message)
                                        break
                                    case "email":
                                        this.emailFieldErrors.push(error.message)
                                        break
                                    case "sexo_id":
                                        this.sexoFieldErrors.push(error.message)
                                        break
                                    case "estado_civil_id":
                                        this.estado_civilFieldErrors.push(error.message)
                                        break
                                    case "campus_id":
                                        this.campusFieldErrors.push(error.message)
                                        break
                                    case "departamento_id":
                                        this.departamentoFieldErrors.push(error.message)
                                        break
                                    case "seccion_id":
                                        this.seccionFieldErrors.push(error.message)
                                        break
                                    case "puesto_id":
                                        this.puestoFieldErrors.push(error.message)
                                        break
                                    case "escolaridad_id":
                                        this.escolaridadesFieldErrors.push(error.message)
                                        break
                                    case "titulo_id":
                                        this.tituloFieldErrors.push(error.message)
                                        break
                                    case "tipo_contratacion":
                                        this.tipo_contratoFieldErrors.push(error.message)
                                        break
                                    case "tipo_pago":
                                        this.tipo_pagoFieldErrors.push(error.message)
                                        break
                                    case "salario":
                                        this.salarioFieldErrors.push(error.message)
                                        break
                                    case "fondo_horario":
                                        this.cantidad_horasFieldErrors.push(error.message)
                                        break
                                    case "plus":
                                        this.salario_plusFieldErrors.push(error.message)
                                        break
                                    case "impuesto_nomina":
                                        this.impuesto_nominaFieldErrors.push(error.message)
                                        break
                                    case "cuota":
                                        this.cuotaFieldErrors.push(error.message)
                                        break
                                    case "isr":
                                        this.isrFieldErrors.push(error.message)
                                        break
                                    case "imss":
                                        this.imssFieldErrors.push(error.message)
                                        break
                                    case "asesor":
                                        this.asesorFieldErrors.push(error.message)
                                        break
                                    case "rcedula":
                                        this.rcedulaFieldErrors.push(error.message)
                                        break
                                    case "rdomicilio":
                                        this.rdomicilioFieldErrors.push(error.message)
                                        break
                                    case "rtitulo":
                                        this.rtituloFieldErrors.push(error.message)
                                        break
                                    case "ractanacido":
                                        this.racta_nacidoFieldErrors.push(error.message)
                                        break
                                    case "rcurp":
                                        this.rcurpFieldErrors.push(error.message)
                                        break
                                    default:
                                        console.log(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },

        cancelForm() {
            this.$emit("formCanceled")
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split("-")
            return `${day}/${month}/${year}`
        },

        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split("/")
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
        },

        contratacionDisableFields() {
            switch (this.empleadoItem.tipo_contratacion) {
                case 1:
                    this.disabledFields = [4]
                    break
                case 2:
                    this.disabledFields = [1, 2, 4]
                    break
                case 3:
                    this.disabledFields = [1, 2, 3]
                    break
                case 4:
                    this.disabledFields = [1, 2, 4]
                    break
                default:
                    this.disabledFields = []
            }
        },

        onChangeFileUpload() {
            this.empleadoItem.foto = this.$refs.file.files[0]
            if (this.empleadoItem.foto !== [] && Util.validateFile(this.empleadoItem.foto.name, ["image"])) {
                this.fotoFieldErrors = []
            } else {
                this.empleadoItem.foto = []
                this.fotoFieldErrors.push("El archivo seleccionado debe ser una imagen")
            }
        }
    },

    watch: {
        dateFecha_nacido: function() {
            this.empleadoItem.fecha_nacido = this.formatDate(this.dateFecha_nacido)
        },

        dateFecha_ingreso: function() {
            this.empleadoItem.fecha_ingreso = this.formatDate(this.dateFecha_ingreso)
        }
    },

    mounted() {
        this.$store.dispatch("LOAD_ALL_CAMPUS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SECCIONES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_DEPARTAMENTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_PUESTOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESCOLARIDADES").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_TITULOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_ESTADOS_CIVIL").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })
        this.$store.dispatch("LOAD_ALL_SEXOS").then(data => {
            if (!data) {
                this.showErrorDataLoadedAlert = true
            }
        })

        if (this.initialItem !== null) {
            // Cargando información del elemento a actualizar
            this.empleadoItem = Object.assign({}, this.initialItem)
            this.empleadoItem.foto = []

            if (!this.initialItem.seccion_id) {
                this.empleadoItem.seccion_id = ""
            }

            if (!this.initialItem.escolaridad_id) {
                this.empleadoItem.escolaridad_id = ""
            }

            if (!this.initialItem.titulo_id) {
                this.empleadoItem.titulo_id = ""
            }

            if (this.initialItem.fecha_nacido) {
                let [dia, mes, ano] = this.initialItem.fecha_nacido.split("/")
                this.empleadoItem.fecha_nacido = ano + "-" + mes + "-" + dia
                this.dateFecha_nacido = this.empleadoItem.fecha_nacido
            }

            if (this.initialItem.fecha_ingreso) {
                let [dia, mes, ano] = this.initialItem.fecha_ingreso.split("/")
                this.empleadoItem.fecha_ingreso = ano + "-" + mes + "-" + dia
                this.dateFecha_ingreso = this.empleadoItem.fecha_ingreso
            }
        }
    }
}
</script>

<style scoped>
.v-alert {
    padding-top: 3px;
    padding-bottom: 4px;
    margin-top: 1px;
    margin-left: 2px;
    margin-right: 2px;
}

input[type="file"] {
    display: none;
}

.error_message {
    font-size: 12px;
    color: #ff5252;
    caret-color: #ff5252;
}
</style>
